import { useEffect, useState } from "react";
import "../../pages/navbar.css";
import taxreport from "../../assets/icon-tax-report.svg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { clientConfig } from "../../awsClientConfig";
import { GetFreeTaxRiskReportEligibility } from "../../queries/GetFreeTaxRiskReportEligibility";
import { LastFreeRiskReports } from "../DashBoards/types";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { userProfileData } from "../../Common/profileInfo";
import { FaClock } from "@react-icons/all-files/fa/FaClock";
function AppEnrollmentSuccessfull() {
  const navigate = useNavigate();
  const [lastTaxReport, setLastTaxReport] = useState<LastFreeRiskReports>();

  useEffect(() => {
    fetchStatus();
  }, []);
  const fetchStatus = async () => {
    
    const profileId = await userProfileData()
    const client = new clientConfig();

    const taxRiskData:any = await client.query({
      query: GetFreeTaxRiskReportEligibility,
      variables: { profileId: profileId },
    });

    console.log(taxRiskData);
    setLastTaxReport(
      taxRiskData.data.GetFreeTaxRiskReportEligibility.LastTaxRiskReport
    );
  };
  return (
    <>
      <Container className="mt-3 mb-5">
        <Row className="row justify-content-center">
          <Col md={10} className="content-box py-5 px-lg-5">
            <Row className="px-lg-5 justify-content-center align-items-center">
              <Col className="col-lg-7">
                <h1 className="content-box-heading mb-3">
                  Application Submitted!{" "}
                </h1>
                <p className="content-text">
                  Thank you for taking the time and applying for your Tax
                  Report. We are currently preparing your report - estimated time
                  of delivery is 2-3 weeks. We appreciate your patience.{" "}
                </p>
                <p className="content-text">
                  Once your report is ready you will get a notification. You
                  will then be able to view your report from your client
                  dashboard.
                </p>
                <p className="fs-6 mb-1">
                  Report Status:{" "}
                  <span className="text-primary fw-bold">
                    {lastTaxReport?.Status === "Pending" ? "Preparing" : ""} <FaClock />
                  </span>{" "}
                </p>
                <p className="fs-6 mb-4">
                  Report Requested:{" "}
                  <span className="fw-bold">
                    {moment(lastTaxReport?.RequestedAt).format("MMM. DD, YYYY")}
                  </span>
                </p>

                <button
                  onClick={() => navigate("/dashboard")}
                  className="btn-xl px-1"
                >
                  Continue to Dashboard
                </button>
              </Col>
              <Col className="col-lg-5">
                <img
                  src={taxreport}
                  alt="Tax-report"
                  className="w-75 d-block mx-auto"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AppEnrollmentSuccessfull;
